module.exports = __webpack_public_path__ + "static/media/sherry.24106d9a.jpg";